module.exports = __webpack_public_path__ + "assets/cargaDatos.2f6d226f77ae9101f18192698e452a52.svg";


//////////////////
// WEBPACK FOOTER
// ./img/cargaDatos.svg
// module id = 585
// module chunks = 0